import { Component, Inject, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ContenuSessionService } from 'src/services/contenu.session.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { ContenuSessionModel } from 'src/models/contenuSessionModel';
import { InfosCertificatModel } from 'src/models/Session/infos-certificat-model';

@Component({
    selector: 'app-choix-langue-certificat-dialog',
    templateUrl: './choix-langue-certificat-dialog.component.html',
    styleUrls: ['./choix-langue-certificat-dialog.component.scss'],
    imports: [
    FormsModule,
    TranslateModule,
    MatFormFieldModule,
    MatProgressSpinnerModule
]
})
export class ChoixLangueCertificatDialogComponent implements OnInit {
  isLoading = false;
  constructor(
        private  contenuSessionService: ContenuSessionService,
        public dialogRef: MatDialogRef<ChoixLangueCertificatDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ContenuSessionModel[],
  ) { }

  ngOnInit() {

  }

  selectedLanguage!: string ;

  onSubmit() {
    if (this.selectedLanguage) {
      this.imprimerCertificat();
    }
  }

  onCancel() {
    this.selectedLanguage = '';
    this.dialogRef.close(false);
  }

  imprimerCertificat(): void {
    this.isLoading = true;
    var infosCertificatModels: InfosCertificatModel[] = [];
    this.data.forEach(element => {
      infosCertificatModels.push(new InfosCertificatModel(element.id, element.utilisateurId));
    });
    this.contenuSessionService.imprimerCertificatUtilisateur(infosCertificatModels, this.selectedLanguage).subscribe(({ blob, contentType }) => {
      if(infosCertificatModels.length == 1){
        this.ouvrirCertificatOnglet(blob,contentType!);
      } else {
        this.telechargerCertificat(blob, contentType!);
      }
      this.isLoading = false;
      this.dialogRef.close(true);
    });
  }

  ouvrirCertificatOnglet(reponse: Blob, type: string) {
    var newBlob: Blob;
    newBlob = new Blob([reponse], { type: type });
    const fileURL = URL.createObjectURL(newBlob);
    window.open(fileURL, '_blank');
  }

  telechargerCertificat(blob: Blob,  type: string) {
    const newBlob = new Blob([blob], { type });
    const fileURL = URL.createObjectURL(newBlob);

    const a = document.createElement('a');
    a.href = fileURL;
    const now = new Date();
    const pad = (n: number) => n.toString().padStart(2, '0');
    const dateStr = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}_${pad(now.getHours())}-${pad(now.getMinutes())}`;
    a.download = `certificats_${dateStr}`
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    setTimeout(() => URL.revokeObjectURL(fileURL), 100);
  }

}
